import { KeyValueIsPrimary, KeyValueTypeModel } from '@models/common';
import { WorkflowState } from '@models/module/workflowState';
import { ComplexConditionGroup } from '@module-definition/complex-conditions/complex-conditions-list/complex-conditions.model';

export const DemoComplexConditions: ComplexConditionGroup[] = [
  {
    id: 107,
    position: 44,
    transitionId: 1173,
    stateId: 657,
    templateId: 545,
    fieldConditions: [
      {
        fieldId: 2949,
        fieldLabel: 'text',
        fieldTypeId: 1,
        operatorId: 6,
        value: 'data',
        value2: '',
        options: [],
      },
      {
        fieldId: 2949,
        fieldLabel: 'text',
        fieldTypeId: 1,
        operatorId: 6,
        value: 'aa',
        value2: '',
        options: [],
      },
    ],
    screenConditions: [],
  },
  {
    id: 108,
    position: 45,
    transitionId: 1173,
    stateId: 657,
    templateId: 546,
    fieldConditions: [
      {
        fieldId: 2950,
        fieldLabel: 'number',
        fieldTypeId: 2,
        operatorId: 14,
        value: '55',
        value2: '',
        options: [],
      },
    ],
    screenConditions: [
      {
        screenId: 2,
        operatorId: 15,
        value: ['val1', 'val2'],
      },
    ],
  },
  {
    id: 109,
    position: 46,
    transitionId: 1173,
    stateId: 656,
    templateId: 545,
    fieldConditions: [
      {
        fieldId: 2950,
        fieldLabel: 'number',
        fieldTypeId: 2,
        operatorId: 13,
        value: 12,
        value2: 18,
        options: [],
      },
    ],
    screenConditions: [],
  },
  {
    id: 110,
    position: 44,
    transitionId: 1173,
    stateId: 657,
    templateId: 545,
    fieldConditions: [],
    screenConditions: [
      {
        screenId: 1,
        operatorId: 3,
        value: 'test',
      },
    ],
  },
];

export const DemoOperatorsDict: KeyValueTypeModel<number>[] = [
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 13,
    value: 'Between',
  },

  {
    typeId: 1,
    type: 'Text',
    displayTypeId: 0,
    key: 6,
    value: 'Contains',
  },
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 14,
    value: 'Does not equal',
  },
  {
    typeId: 3,
    type: 'Text',
    displayTypeId: 0,
    key: 11,
    value: 'True',
  },

  {
    typeId: 1,
    type: 'Text',
    displayTypeId: 0,
    key: 3,
    value: 'Equals',
  },
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 1,
    value: 'Less Then',
  },
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 2,
    value: 'Grater Then',
  },
  {
    typeId: 1,
    type: 'Text',
    displayTypeId: 0,
    key: 4,
    value: 'Strats With',
  },
  {
    typeId: 1,
    type: 'Text',
    displayTypeId: 0,
    key: 5,
    value: 'Ends With',
  },
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 7,
    value: 'Less Then Or Equal',
  },
  {
    typeId: 2,
    type: 'Number',
    displayTypeId: 0,
    key: 8,
    value: 'Greater Then Or Equals',
  },
  {
    typeId: 1,
    type: 'Number',
    displayTypeId: 3,
    key: 9,
    value: 'Is Empty',
  },
  {
    typeId: 1,
    type: 'Number',
    displayTypeId: 3,
    key: 10,
    value: 'Is Not Empty',
  },
  {
    typeId: 3,
    type: 'Number',
    displayTypeId: 0,
    key: 12,
    value: 'False',
  },
  {
    typeId: 1,
    type: 'Select',
    displayTypeId: 3,
    key: 15,
    value: 'Select',
  },
];

export const DemoConditionalsFieldsDict: KeyValueTypeModel<number>[] = [
  {
    typeId: 1,
    displayTypeId: 0,
    key: 2949,
    value: 'text',
  },
  {
    typeId: 2,
    displayTypeId: 0,
    key: 2950,
    value: 'number',
  },
  {
    typeId: 1,
    displayTypeId: 3,
    key: 2951,
    value: 'bool',
  },
  {
    typeId: 3,
    displayTypeId: 0,
    key: 2952,
    value: 'flag',
  },
];

export const DemoStateDefinition: WorkflowState[] = [
  {
    id: 657,
    typeId: 6,
    name: 'Open Con',
    color: '#e171ef',
    textColor: 'fff',
    default: false,
    type: 2,
    deleted: false,
    hasRevise: false,
    ballInCourtRoleIds: [],
    nonBindingSignTransitions: [],
    roleIds: [],
    transitions: [],
    actions: [],
    signTransitions: [],
    approvalRoleIds: [],
    notifyDocumentInitiator: false,
    workflowId: 181,
    position: 3,
  },

  {
    id: 656,
    typeId: 6,
    name: 'Open',
    color: '#0091ff',
    textColor: '#fff',
    default: false,
    type: 2,
    roleIds: [],
    ballInCourtRoleIds: [],
    transitions: [],
    actions: [],
    signTransitions: [],
    nonBindingSignTransitions: [],
    approvalRoleIds: [],
    hasRevise: false,
    notifyDocumentInitiator: false,
    workflowId: 181,
    deleted: false,
    position: 2,
  },
];

export const DemoTemplateDict: (KeyValueIsPrimary<number> & { isConditional: boolean })[] = [
  {
    isConditional: false,
    isPrimary: false,
    key: 545,
    value: 'print cond',
  },
  {
    isConditional: false,
    isPrimary: false,
    key: 546,
    value: 'print default',
    description: '',
  },
];
